// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyADyw85smG8ymvk5BSsTq5AJ2viVwLcOj8",
  authDomain: "whizcomms-esim.firebaseapp.com",
  projectId: "whizcomms-esim",
  storageBucket: "whizcomms-esim.firebasestorage.app",
  messagingSenderId: "200052801909",
  appId: "1:200052801909:web:231ddcf84dfff54a31533c",
  measurementId: "G-XGS1M7VF70"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser environment)
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { app, analytics };

